import BaseAPI from './BaseAPI';

// Square payment mirror (`payments` + `orders` tables), under /payments.
class PaymentsAPI extends BaseAPI {
  constructor() {
    super('payments');
  }

  // GET /payments?start=&end= → { payments: [...] } (enriched transactions)
  list(start, end) {
    return this.get(`/?start=${start}&end=${end}`);
  }

  // POST /payments/sync?date= → { count } (refetches payments + orders from Square)
  sync(date) {
    return this.post(`/sync${date ? `?date=${date}` : ''}`);
  }

  // GET /payments/customer-appointments?customerId= → { appointments: [...] }
  customerAppointments(customerId) {
    return this.get(`/customer-appointments?customerId=${encodeURIComponent(customerId)}`);
  }

  // GET /payments/methods → { methods: [...] } (the payment picker's options)
  methods() {
    return this.get('/methods');
  }

  // POST /payments/manual → records a non-Square payment (cash, e-transfer,
  // invoice, hotel account, comp, ghost).
  recordManual(payload) {
    return this.post('/manual', { body: payload });
  }

  // PUT /payments/:idPayment/verify — a second person confirms a manual entry.
  verify(idPayment) {
    return this.put(`/${idPayment}/verify`);
  }

  // PUT /payments/:idPayment/settle — mark an outstanding receivable collected.
  settle(idPayment, settledAt) {
    return this.put(`/${idPayment}/settle`, { body: { settledAt } });
  }

  // PUT /payments/orders/:orderId/appointment { bookId } — link/unlink (admin)
  setAppointment(orderId, bookId) {
    return this.put(`/orders/${encodeURIComponent(orderId)}/appointment`, { body: { bookId } });
  }
}

export const PaymentsService = new PaymentsAPI();
export default PaymentsAPI;
